import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const REPORT_PERMISSIONS = {
  READ: PERMISSIONS.REPORTS_READ,
};

export const REPORT_QUERY_KEYS = queryKeys.reports;
